<template>
  <div>
    <v-app-bar flat color="transparent" class="main-appbar">
      <app-bar-nav-icon />
      <div class="d-flex align-center">
        <v-toolbar-title>
          <h1 class="headline font-weight-bold">Sports Books</h1>
        </v-toolbar-title>
      </div>
      <v-spacer/>
      <v-btn
        color="primary"
        dark
        class="ml-4"
        :to="{name: 'sportsbooks.create'}"
      >
        <v-icon class="mr-2 body-1">mdi-pencil</v-icon>
        <span style="text-transform: none">Create New</span>
      </v-btn>
    </v-app-bar>
    <div class="px-4 pt-4">
      <v-select style="width:320px" label="States" clearable dense outlined></v-select>
    </div>
    <v-row class="px-4">
      <v-col xl="3" lg="4" md="6" sm="12" v-for="book in sportsBooksList" :key="book.id">
        <bookmaker-card-item :value="book"/>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import { mapState, mapActions } from 'vuex'
import get from 'lodash/get'
import BookmakerCardItem from './components/BookmakerCardItem'

export default {
  components: {
    AppBarNavIcon,
    BookmakerCardItem
  },
  computed: {
    ...mapState({
      sportsBooksList: state => state.bookmaker.list
    })
  },
  mounted () {
    this.fetchSportsBookList()
  },
  methods: {
    get,
    ...mapActions({
      getBookList: 'bookmaker/getBookList'
    }),
    async fetchSportsBookList (page = 1) {
      let params = { page }

      params.sort = '-created_at'
      this.loading = true
      await this.getBookList(params)
      this.loading = false
    }
  }
}
</script>
<style   scoped>
 .bottom-gradient {
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.4) 0%, transparent 72px);
  }
</style>
